<template>
  <!--
  ==========================================================================
  General
  ==========================================================================
  -->
  <form class="h-100 scrollable padded">
    <network-form-field
      :label="$t('provider.fields.network')"
      required
      :value="value.network"
      :error="findError('network')"
      :disabled="disabled"
      @input="propertyChange('network', $event)"
    />

    <string-form-field
      :label="$t('provider.fields.companyName')"
      required
      :value="value.companyName"
      :error="findError('companyName')"
      :disabled="disabled"
      @input="propertyChange('companyName', $event)"
    />

    <b-row>
      <string-form-field
        :label="$t('provider.fields.fiscalCode')"
        required
        :value="value.fiscalCode"
        :error="findError('fiscalCode')"
        :disabled="disabled"
        class="col-md-6"
        @input="propertyChange('fiscalCode', $event)"
      />
      <string-form-field
        :label="$t('provider.fields.vatNumber')"
        required
        :value="value.vatNumber"
        :error="findError('vatNumber')"
        :disabled="disabled"
        class="col-md-6"
        @input="propertyChange('vatNumber', $event)"
      />
    </b-row>
  </form>
</template>
<script>
import EditorMixin from "vue-template/common/mixins/EditorMixin";
import ErrorCounterMixin from "vue-forms/mixins/ErrorCounterMixin";
import NetworkFormField from "@/modules/network/protected/NetworkFormField";

export default {
  mixins: [EditorMixin, ErrorCounterMixin],

  components: {
    NetworkFormField
  }
};
</script>
